import type { ConfigType } from '@plone/registry';
import Libras from '@plonegovbr/volto-vlibras/components/Libras';
import CardBlockGridItem from '../components/Grid/CardBlockGridItem';

type apiExpanderInherit = {
  match: string;
  GET_CONTENT: string[];
  querystring:
    | { [key: string]: string }
    | ((
        config,
        querystring: { config: ConfigType; querystring: object },
      ) => { [key: string]: string });
};

type DSGovSettings = {
  doNotDisplayChildren: string[];
};

declare module '@plone/types' {
  export interface SettingsConfig {
    dsgov_navigation: DSGovSettings;
  }
}

export default function install(config: ConfigType) {
  // Language settings
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['pt-br'];
  config.settings.defaultLanguage = 'pt-br';

  // Navigation
  config.settings.navDepth = 3;

  // Display Plone Login Form
  config.settings.showPloneLogin = true;

  // Configura navegação
  config.settings.dsgov_navigation = {
    doNotDisplayChildren: ['Area', 'Campus'],
  };

  // VLibras
  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: Libras,
    },
  ];

  // Inherit
  const inheritBehaviors =
    'plonegovbr.socialmedia.settings,ifpb.portal.header,voltolighttheme.theme,voltolighttheme.footer';
  config.settings.apiExpanders = [
    ...config.settings.apiExpanders,
    {
      match: '',
      GET_CONTENT: ['inherit'],
      querystring: (config, querystring) => {
        if (querystring['expand.inherit.behaviors']) {
          return {
            'expand.inherit.behaviors': querystring[
              'expand.inherit.behaviors'
            ].concat(',', inheritBehaviors),
          };
        } else {
          return {
            'expand.inherit.behaviors': inheritBehaviors,
          };
        }
      },
    } as apiExpanderInherit,
  ];

  config.registerComponent({
    name: 'GridListingItemTemplate',
    component: CardBlockGridItem,
    dependencies: 'cardBlock',
  });

  return config;
}
